import { buildPcsFindByUuidUrl, getAutoplayType, getVideoApiUrl } from ".";

/**
 *
 * @param {string} originalVideo - The first video played in this orca player
 * @param {boolean} isSandbox - Whether the video player is in a sandbox environment.
 * @returns {array} an array of video ANS objects
 */
export const fetchRecommendedPlaylist = async (originalVideo, isSandbox) => {
  const originalVideoIsVertical = videoIsVertical(originalVideo);

  try {
    const url = buildPcsFindByUuidUrl(getVideoApiUrl(isSandbox), {
      uuid: originalVideo?._id,
      recommendedPlaylist: 1,
      playlistCount: 1
    });
    const response = await fetch(url);
    const data = await response.json();

    if (!Array.isArray(data)) {
      console.error(
        `Video API request for recommended playlist for UUID = ${originalVideo?._id} returned an error:`,
        data
      );
      return [];
    }

    const filteredVideos = data
      .filter(
        video =>
          filterByMatchingOrientation(video, originalVideoIsVertical) &&
          filterOutAutoPlayingVideos(video)
      )
      // remove the first item in the api results, since it's the original video
      .slice(1);
    return filteredVideos;
  } catch (error) {
    console.error(
      `Video API request for recommended playlist for UUID = ${originalVideo?._id} failed: ${error}`
    );
    return [];
  }
};

const videoIsVertical = video => {
  const { vertical = false, videoCategory = "" } = video.additional_properties;
  return vertical || videoCategory === "vertical";
};

/**
 * Filter for fetched videos to ensure that the horizontal/vertical
 * orientation of video recs matches the orientation of the original video
 * @param {Object} video - The video object to filter.
 * @param {boolean} originalVideoIsVertical - A boolean indicating whether the
 * original video is vertical.
 * @returns {boolean} - A boolean indicating whether the video matches the
 * orientation of the original video.
 */
const filterByMatchingOrientation = (video, originalVideoIsVertical) => {
  return videoIsVertical(video) === originalVideoIsVertical;
};

/**
 * Filter out auto playing videos, including looping videos
 * @param {Object} video - The video object to filter.
 * @returns {boolean} - Returns true if the video is not an autoplay video, false otherwise.
 */
const filterOutAutoPlayingVideos = video => {
  const isAutoPlayVideo = getAutoplayType(video);
  return !isAutoPlayVideo;
};
